/**
 * data-types.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

export type ServerDataType =
    "string" | "boolean" | "date" | "float" | "integer" | "whole number"
    | "natural number";

export const SERVER_TYPES : ServerDataType[] = [
    "string", "boolean", "date", "float", "integer", "whole number",
    "natural number"
];

export type DataType =
    ServerDataType | AggregationDataType | ClientInternalType | "parseable";

export type ClientInternalType = "datetime" | "json" | "empty" | "html";

export type AggregationDataType =
    ServerDataType | "frequency" | "subject context";

export type CollectionType = "list" | "set" | "none";

export const IntegerTypes : Set<DataType> = new Set(
    ["integer", "whole number", "natural number"] as DataType[]);

export const NumberTypeOrder : DataType[] =
    ["natural number", "whole number", "integer", "float"];

export const NumberTypes : Set<DataType> = new Set(NumberTypeOrder);



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/common/data/data-types.ts